import React, { forwardRef, useImperativeHandle, useState } from "react"

import BlurWrapper from "@fuse/sharedComponents/blurWrapper"

import QuestionMark from "@fuse/assets/images/img-question-mark.png"

export interface WhatHappensAfterGoLiveHandle {
  openModal: () => void
  closeModal: () => void
}

const WhatHappensAfterGoLive = forwardRef<WhatHappensAfterGoLiveHandle>(
  (_, ref) => {
    const [isVisible, setIsVisible] = useState(false)

    // Expose methods to parent via ref
    useImperativeHandle(ref, () => ({
      openModal: () => {
        setIsVisible(true)
      },
      closeModal: () => {
        setIsVisible(false)
      },
    }))

    if (!isVisible) return null
    return (
      <div
        onClick={() => setIsVisible(false)}
        className="fixed inset-0 flex justify-center bg-black bg-opacity-50 z-[100] items-end md:items-center place-items-center"
      >
        <BlurWrapper
          overlayOpacityDefault="20"
          className="w-full md:max-w-sm !bg-gray-500/10 rounded-t-2xl md:rounded-2xl p-6 px-14 relative flex flex-col cursor-auto place-content-center"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex flex-col items-center justify-center gap-5 py-4">
            <div className="flex flex-col items-center justify-center gap-5 h-40 w-40 bg-white/10 rounded-[40px]">
              <div>
                <img
                  src={QuestionMark}
                  alt="event"
                  className="w-32 h-32 mx-auto object-contain"
                />
              </div>
            </div>

            <p className="text-white text-center text-lg">
              Once you go live, you can share your event with friends — <br />{" "}
              totally FREEEEE!🙌 <br />
              <br />
              You’re just one step away. Let’s do this! 🚀
            </p>

            <div
              className="w-full flex items-center justify-center gap-5 bg-white/10 rounded-full py-3 mt-8"
              onClick={() => setIsVisible(false)}
            >
              <p className="text-white text-base">Got it</p>
            </div>
          </div>
        </BlurWrapper>
      </div>
    )
  },
)

export default WhatHappensAfterGoLive
